import { render, staticRenderFns } from "./pemantauan.vue?vue&type=template&id=ade66a8c&"
import script from "./pemantauan.vue?vue&type=script&lang=js&"
export * from "./pemantauan.vue?vue&type=script&lang=js&"
import style0 from "./pemantauan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports